import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import AdminApiClient from '../../../utils/http-clients/AdminApiClient'
import { IDeleteState, IResponse } from '../../types'

const adminApiClient = AdminApiClient.getInstance()

export const fetchDeleteROC = createAsyncThunk(
  'listCompanies/fetchDeleteROC',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await adminApiClient.deleteROC(id)
      return response.data
    } catch (error: any) {
      if (!error.response) {
        throw error
      }

      return rejectWithValue(error)
    }
  }
)

const initialState: IDeleteState = {
  isLoading: false,
  response: null,
  error: null
}

const deleteROCSlice = createSlice({
  name: 'Companies/delete',
  initialState,
  reducers: {
    resetDeleteROC: () => initialState
  },
  extraReducers: builder => {
    builder.addCase(fetchDeleteROC.pending, state => {
      state.isLoading = true
      state.response = null
      state.error = null
    })

    builder.addCase(fetchDeleteROC.fulfilled, (state, action: PayloadAction<IResponse>) => {
      state.isLoading = false
      state.response = action.payload
      state.error = null
    })

    builder.addCase(fetchDeleteROC.rejected, (state, action) => {
      state.isLoading = false
      state.response = null
      state.error = action.payload
    })
  }
})

export default deleteROCSlice.reducer
export const { resetDeleteROC } = deleteROCSlice.actions
